(function () {
    'use strict';
    angular
        .module('app')
        .controller('questionBox', questionBox);
    questionBox.$inject = ['$rootScope', '$scope', '$mdDialog', 'loginService', '$timeout'];
    function questionBox($rootScope, scope, $mdDialog, loginService, $timeout) {
        scope.loginService = loginService;

        // Initialized in confirmBoxShow.
        scope.questionBox = $rootScope.questionBox;

        scope.sendEvents = function (result) {
            // Close the dialog.
            $mdDialog.hide();

            // Put a delay in here so that the user sees the dialog go away.
            // Otherwise if another question is asked, it looks like nothign happened.
            $timeout(function () {
                // Fire the POST event.
                if (scope.questionBox.postCloseCallback != null)
                    scope.questionBox.postCloseCallback($rootScope.questionBox.param1, $rootScope.questionBox.param2, result);
            }, 500)
        }

        scope.onQuestionBoxYes = function () {
            scope.sendEvents('Y');
        }

        scope.onQuestionBoxYesToAll = function () {
            scope.sendEvents('YtoAll');
        }

        scope.onQuestionBoxNo = function () {
            scope.sendEvents('N');
        }

        scope.onQuestionBoxNoToAll = function () {
            scope.sendEvents('NtoAll');
        }

        function activate() { }
        activate();
    }
})();
